/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_TitleInputs */

const en_sorter_title = /** @type {(inputs: Sorter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Key Sorter`)
};

const ko_sorter_title = /** @type {(inputs: Sorter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 키 정렬기`)
};

const ja_sorter_title = /** @type {(inputs: Sorter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONキーソーター`)
};

/**
* | output |
* | --- |
* | "JSON Key Sorter" |
*
* @param {Sorter_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_title = /** @type {((inputs?: Sorter_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_title(inputs)
	if (locale === "ko") return ko_sorter_title(inputs)
	return ja_sorter_title(inputs)
});